"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithStylusClick = exports.StylusAdapter = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var docs_user_agent_1 = tslib_1.__importDefault(require("@tencent/docs-user-agent"));
var TouchType;
(function (TouchType) {
    TouchType["direct"] = "direct";
    TouchType["stylus"] = "stylus";
})(TouchType || (TouchType = {}));
var StylusAdapter = (function () {
    function StylusAdapter() {
    }
    StylusAdapter.supportStylus = function (event, callback) {
        if (!this.isIPadStylusTouch(event)) {
            return;
        }
        if (event.nativeEvent.type === 'touchstart') {
            this.startPos = [event.changedTouches[0].clientX, event.changedTouches[0].clientY];
            return;
        }
        if (event.nativeEvent.type === 'touchend') {
            var endPos = [event.changedTouches[0].clientX, event.changedTouches[0].clientY];
            if (this.isEqualPos(this.startPos, endPos) && callback) {
                callback();
            }
            event.preventDefault();
        }
    };
    StylusAdapter.startPos = [0, 0];
    StylusAdapter.isIPadStylusTouch = function (event) { return (docs_user_agent_1.default.isIPad && event.changedTouches[0] && event.changedTouches[0].touchType === TouchType.stylus); };
    StylusAdapter.isEqualPos = function (pos1, pos2) { return (Math.abs(pos1[0] - pos2[0]) < 10 && Math.abs(pos1[1] - pos2[1]) < 10); };
    return StylusAdapter;
}());
exports.StylusAdapter = StylusAdapter;
var WithStylusClick = function (_a) {
    var children = _a.children, clickHandler = _a.clickHandler;
    return react_1.default.cloneElement(children, {
        onClick: clickHandler,
        onTouchStart: function (e) { return StylusAdapter.supportStylus(e, clickHandler); },
        onTouchEnd: function (e) { return StylusAdapter.supportStylus(e, clickHandler); },
    });
};
exports.WithStylusClick = WithStylusClick;
